<div class="gs-event-selector">
  <div class="gs-event-selector-header">
    <span>Select events</span>
    <span class="gs-event-selector-count" data-cy="gs-event-selector-count">
      {{ selectedIds.length }} / {{ totalItems }}
    </span>
  </div>

  <gs-selectable-list
    [items]="items"
    idKey="id"
    titleKey="description"
    subtitleKey="subtitle"
    [mode]="mode"
    [pageSize]="pageSize"
    [searchable]="searchable"
    [disabledIds]="disabledIds"
    [serverSide]="true"
    [page]="currentPage"
    [totalItems]="totalItems"
    [disabled]="isDisabled"
    [loading]="isLoading"
    [ngModel]="selectedIds"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="onSelectionChange($event)"
    (pageChange)="onPageChange($event)"
    (selectionMeta)="selectionMeta.emit($event)" />
</div>
